import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import MetaFormFields from 'Views/Onboarding/Pages/Survey/SurveyStep/Components/MetaFormFields';
import Title from 'Components/ComponentLibrary/Atoms/Text/Title';
import { PrimaryActionButton } from '@facet-wealth/design';
import ActionsRow from 'Components/ComponentLibrary/Atoms/Layout/ActionsRow';
import RelationshipLinkButtons from './RelationshipLinkButtons';

const styles = (theme) => ({
  root: {},
  title: {
    marginBottom: theme.spacing(2),
  },
  content: {
    margin: 'auto',
    maxWidth: theme.dimensions.sm,
  },
});

const Content = ({
  className,
  classes,
}) => {
  const { setPageContentCollection, pageContentResource } = usePageContentContext();
  const { resource, onSubmit } = useMetaLayoutContext();
  const [submitting, setSubmitting] = useState(false);

  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <Title
        text={pageContentResource.attr('title')}
        className={classes.title}
      />
      <Box className={classes.content}>
        <MetaFormFields
          className={classes.fields}
          resource={resource}
        />
        <RelationshipLinkButtons resource={pageContentResource} />
        <ActionsRow>
          <PrimaryActionButton
            onClick={async () => {
              try {
                setSubmitting(true);
                const resp = await onSubmit();
                setSubmitting(false);
                if (resp) {
                  setPageContentCollection(resp);
                }
              } catch (err) {
                setSubmitting(false);
              }
            }}
            loading={submitting}
            disabled={submitting}
            isFullWidth
            size="lg"
            label="Submit"
          />
        </ActionsRow>
      </Box>

    </Box>
  );
};

Content.defaultProps = {
  className: '',
};

Content.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Content);
